/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.event', [])
    .factory('eventService', EventService)
    .name;

/*@ngInject*/
function EventService($http, $q) {

    var service = {
        getEntityEvents: getEntityEvents,
        getEntityRaisedEvents: getEntityRaisedEvents,
        getAllEvents: getAllEvents,
        getAllRaisedEvents: getAllRaisedEvents
    }

    return service;

    function createEntityEventsParameters(states, severities, eventNames, /*ituTypes,*/ eventType, endTs) {
        var parameters = "";
        if (endTs) {
            parameters += `&endTs=${endTs}`;
        }
        if (eventType) {
            parameters += `&eventType=${eventType}`;
        }
        if (states && states.length) {
            parameters += `&state=${states.join(',')}`;
        }
        if (severities && severities.length) {
            parameters += `&severity=${severities.join(',')}`;
        }
        if (eventNames && eventNames.length) {
            parameters += `&eventName=${eventNames.join(',')}`;
        }
        // if (ituTypes && ituTypes.length) {
        //     parameters += `&ituType=${ituTypes.join(',')}`;
        // }
        return parameters;
    }

    function getEntityEvents(entityType, states, severities, eventNames, /*ituTypes,*/ entityId, eventType, startTs, endTs, limit, page) {
        var deferred = $q.defer();
        var url = `/api/enhancedEvents?source=${entityType}&entityIdUuid=${entityId}&startTs=${startTs}&limit=${limit}&page=${page}`;
        url += createEntityEventsParameters(states, severities, eventNames, /*ituTypes,*/ eventType, endTs);
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getEntityRaisedEvents(entityType, states, severities, eventNames, /*ituTypes,*/ entityId, eventType, startTs, endTs, limit, page) {
        var deferred = $q.defer();
        var url = `/api/enhancedEventsRaised?source=${entityType}&entityIdUuid=${entityId}&startTs=${startTs}&limit=${limit}&page=${page}`;
        url += createEntityEventsParameters(states, severities, eventNames, /*ituTypes,*/ eventType, endTs);
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function createAllEventsParameters(eventTypes, states, severities, eventNames, /*ituTypes,*/ entityName, sources, endTs) {
        var parameters = "";
        if (endTs) {
            parameters += `&endTs=${endTs}`;
        }
        if (eventTypes && eventTypes.length) {
            parameters += `&eventType=${eventTypes.join(',')}`;
        }
        if (states && states.length) {
            parameters += `&state=${states.join(',')}`;
        }
        if (severities && severities.length) {
            parameters += `&severity=${severities.join(',')}`;
        }
        if (eventNames && eventNames.length) {
            parameters += `&eventName=${eventNames.join(',')}`;
        }
        // if (ituTypes && ituTypes.length) {
        //     parameters += `&ituType=${ituTypes.join(',')}`;
        // }
        if (entityName) {
            parameters += `&entityName=${encodeURIComponent(entityName)}`;
        }
        if (sources && sources.length) {
            parameters += `&source=${sources.join(',')}`;
        }
        return parameters;
    }

    function getAllEvents(eventTypes, states, severities, eventNames, /*ituTypes,*/ entityName, sources, startTs, endTs, limit, page) {
        var deferred = $q.defer();
        var url = `/api/enhancedEvents?startTs=${startTs}&limit=${limit}&page=${page}`;
        url += createAllEventsParameters(eventTypes, states, severities, eventNames, /*ituTypes,*/ entityName, sources, endTs);
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getAllRaisedEvents(eventTypes, states, severities, eventNames, /*ituTypes,*/ entityName, sources, startTs, endTs, limit, page) {
        var deferred = $q.defer();
        var url = `/api/enhancedEventsRaised?startTs=${startTs}&limit=${limit}&page=${page}`;
        url += createAllEventsParameters(eventTypes, states, severities, eventNames, /*ituTypes,*/ entityName, sources, endTs);
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/event.service.js